import { useTranslation } from 'react-i18next';
import { ButtonDropdownSingleSelect, Form } from '@anytag/shared-atoms';
import { SortOption, SortType } from '@anytag/shared-types';

export interface UGCPostSortProps<T extends string> {
  sort: SortType<T>;
  options: SortOption<T>[];
  onChange?: (sortOption: SortOption<T>) => void;
}

export const UGCPostSort = <T extends string>({ sort, options, onChange }: UGCPostSortProps<T>) => {
  const { t } = useTranslation();

  return (
    <Form.Field className="flex-none">
      <ButtonDropdownSingleSelect
        variant="outline"
        options={options}
        title={t<string>('Button.Sort')}
        prefixIcon={{ icon: 'sort', size: '14px' }}
        onSelectOption={(option) => onChange?.(option)}
        selectedOption={options.find((o) => o.field === sort.field && o.order === sort.order)}
      />
    </Form.Field>
  );
};
